var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 682,
    viewBox: "0 0 682 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6433_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M679.557 261.356C675.097 247.56 662.86 237.761 648.383 236.456L451.732 218.6L373.97 36.5923C368.237 23.2535 355.179 14.6191 340.67 14.6191C326.162 14.6191 313.104 23.2535 307.37 36.6235L229.609 218.6L32.9259 236.456C18.4747 237.792 6.26906 247.56 1.78293 261.356C-2.7032 275.152 1.43984 290.285 12.3719 299.824L161.017 430.186L117.185 623.267C113.978 637.463 119.488 652.138 131.267 660.653C137.599 665.227 145.006 667.556 152.476 667.556C158.917 667.556 165.306 665.82 171.039 662.389L340.67 561.007L510.238 662.389C522.647 669.854 538.288 669.173 550.042 660.653C561.826 652.112 567.331 637.432 564.124 623.267L520.292 430.186L668.937 299.85C679.869 290.285 684.043 275.178 679.557 261.356Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6433_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 681.333,
    height: 681.333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3d1a28010a3126a089ae97e6f9347193.svg";
export { ForwardRef as ReactComponent };